import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { ExpressionOfInterestFeatureNames, ExpressionOfInterestService } from '@rma/dashboard/account/expression-of-interest';
import { CalloutComponent } from '@rma/dashboard/generic/ui/callout';
import { RmaLetModule } from '@rma/dashboard/generic/ui/let';
import { LoadingIndicatorDirective } from '@rma/dashboard/generic/ui/loading-indicator';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { NavigationHeaderComponent } from '@rma/dashboard/layout/public/navigation-header';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { map, Observable, startWith, Subject, take } from 'rxjs';

const scope = 'unsubscribeFeatures';

@Component({
  selector: 'rma-unsubscribe-feature-eoi',
  imports: [
    AsyncPipe,
    CalloutComponent,
    LoadingIndicatorDirective,
    MatButtonModule,
    MatCardModule,
    NavigationHeaderComponent,
    RmaIconComponent,
    RmaLetModule,
    RouterLink,
    StaticImageUrlPipe,
    TranslocoModule,
  ],
  templateUrl: './unsubscribe-feature-eoi.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope(scope)],
})
export class UnsubscribeFeatureEoiComponent {
  private readonly expressionOfInterestService = inject(ExpressionOfInterestService);

  protected readonly scope = `${scope}.eoi`;

  protected displayCallout$: Observable<boolean>;
  protected loading$: Observable<boolean>;

  private displayCallout = new Subject<boolean>();
  private loading = new Subject<boolean>();

  constructor() {
    this.displayCallout$ = this.displayCallout.asObservable().pipe(startWith(false));
    this.loading$ = this.loading.asObservable().pipe(startWith(false));

    this.expressionOfInterestService
      .getExpressionOfInterest(ExpressionOfInterestFeatureNames.ReviewsOnlySubscription)
      .pipe(
        take(1),
        map((response) => !!response),
      )
      .subscribe((hasExpressedInterest) => {
        this.displayCallout.next(hasExpressedInterest);
      });
  }

  onInterestedClick(): void {
    this.loading.next(true);
    this.expressionOfInterestService
      .postExpressionOfInterest({
        featureName: ExpressionOfInterestFeatureNames.ReviewsOnlySubscription,
      })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.displayCallout.next(true);
        },
        error: () => {
          // Probably not a big enough issue to even bother the user with an error
          this.displayCallout.next(true);
        },
        complete: () => {
          this.loading.next(false);
        },
      });
  }
}
